import {
    setAdtfDeviceDetails,
    fetchAdtfDeviceDetails,
    deleteAdtfDeviceDetails,
    updateAdtfDeviceDetails,
    updateAdtfConfiguration,
    fetchAdtfStatusDetails,
    updateAdtfDeviceMac,
    updateAdtfMonitoringDetails
} from "../network/AdtfDeviceOverviewNetworkAPI";
import {getTimestampNow} from "../../../util/Util";

export const AdtfDeviceOverviewReducer = (state, action) => {
    switch (action.type) {
        case "RECEIVE_DATA":
            return {...state, ...action.data, loadingOverview: false, timestamp: getTimestampNow()}
        case "LOAD_VIEW":
            fetchAdtfDeviceDetails(action.data.dispatcher)
            return state
        case "LOAD_STATUS":
            fetchAdtfStatusDetails(action.data.dispatcher, state)
            return state
        case "UPDATE_ADTF_CONFIGURATION":
            updateAdtfConfiguration(action.data.dispatcher, action.data.configurations, action.data.mac,  action.data.showCustomAlert)
            return state
        case "ADD_DEVICE_DATA":
            setAdtfDeviceDetails(action.data.dispatcher, action.data.stateValues, action.data.showCustomAlert)
            return state
        case "UPDATE_DEVICE_DATA":
            updateAdtfDeviceDetails(action.data.dispatcher, action.data.stateValues, action.data.showCustomAlert)
            return state
        case "UPDATE_DEVICE_MAC":
            updateAdtfDeviceMac(action.data.dispatcher, action.data.stateValues, action.data.mac, action.data.showCustomAlert)
            return state
        case "DELETE_DEVICE_DATA":
            deleteAdtfDeviceDetails(action.data.dispatcher, action.data.mac)
            return state
        case "SORT_DATA":
            return {...state, sortPref: action.data}
        case "UPDATE_MONITORING_DATA":
            updateAdtfMonitoringDetails(action.data.dispatcher, action.data.stateValues, action.data.mac)
            return state
        default:
            return state
    }
}



// WEBPACK FOOTER //
// ./src/components/devicemanagement/adtfdevice/reducer/AdtfDeviceOverviewReducer.js